import { NormalizedCacheObject } from '@apollo/client';
import { CachePersistor, LocalForageWrapper } from 'apollo3-cache-persist';
import ApolloCache from 'ApolloCache';
import localforage from 'localforage';

let persistor: CachePersistor<NormalizedCacheObject>;

export function getPersistor(reset = false) {
  if (reset || !persistor) {
    const cache = ApolloCache;
    persistor = new CachePersistor({
      cache,
      storage: new LocalForageWrapper(localforage),
      debug: process.env.REACT_APP_ENVIRONMENT === 'development',
      trigger: 'write',
      maxSize: 1024 * 1024 * 8, // 8MB
    });
  }

  return persistor;
}
